import React, {useState} from 'react'
import ImageGrid from '../components/ImageGrid';
import Modal  from '../components/Modal';
import Title from '../components/footer';
import NavBar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import { Image } from 'react-native-web';

const Home = () => {

    const [isOpen, setIsOpen] = useState(false)

    const toggle =() =>{
      setIsOpen(!isOpen)
    };

    const [selectedImg, setSelectedImg] = useState(null);
    return (
        <body class="">
          <div class="wrapper">

            <Sidebar isOpen={isOpen} toggle={toggle}/>
            <NavBar toggle={toggle}/>
        
            <div class='container hero'>
                <h1>Imaginary Art Store</h1>
                <h2>Focus on what really matters <span class="highlight">CREATION</span></h2>
                <p class="disclaimer">Our goal is to help Artists sell thier works in the most efficient way possible. <a href="/questions/" class="learn-more">Learn more</a></p>
            </div>

            <section class="feedSlide">
              <div class="scroll"></div>
            </section>

            <section className='block center offgrid'>
              <br/>
              <h2>Habit based suggestions</h2>
              <p>Our suggestions <span class="highlight">algorithm</span>, picks up on your habits and offers suggestions on art pieces you'd definatly love to buy</p>
              <br />

              <picture>
                
                  <img src={require('../images/algorithm_image.png')} width="1657" height="787" alt="Imaginary Art Store Mobile App" loading="lazy" decoding="async"/>
              </picture>
            </section>

            <section className='block grid-columns two'>

              <div class="text">
                <h2>No fake reviews!</h2>
                <p>BE CONFIDENT. All reviews on our store are from <span class="highlight">verified</span> purchases only. This is done in an effort to garantee you the best shopping experience.</p>
              </div>
              
              <div class="figure">
                <picture>
                  <img src={require('../images/ratings_screenshot.png')} width="512" height="512" alt="Imaginary Art Store Mobile App" loading="lazy" decoding="async"/>
              </picture>
              </div>
              
            </section>

             <section className='block grid-columns two'>

              <div class="figure">
                <picture>
                  <img src={require('../images/image3.png')} width="512" height="512" alt="Imaginary Art Store Mobile App" loading="lazy" decoding="async"/>
                </picture>
              </div>

              <div class="text">
                <h3>Connect with the world</h3>
                <p>Buy works from artists all over the <span class="highlight">globe</span>. Imaginary Art Store is available everywhere on earth</p>
              </div>
              
            </section>

            
                    
            
           
          </div>
          <Title/>
       
        </body>
    )
}

export default Home
